export default __webpack_public_path__ + "static/media/print-preview.3aa96d5e.svg";